import './App.css';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Signin from './signin/Signin';
import NotFoundPage from './common-pages/NotFoundPage';
import Home from './home/Homepage';
import WorkSession from './work-session/WorkSession';
import Task from './task/Task';
import CompitoLandingPage from "./common-pages/CompitoLandingPage";
import Signup from "./signup/Signup";
import PrivateRouter from "./authentication/PrivateRouter";
import Recall from "./recall/Recall";
import ProjectsPage from "./project/ProjectsPage";
import Notes from "./note/Notes";
import Note from "./note/Note";
import Planner from "./planner/Planner";
import Settings from "./settings/Settings";
import KnowledgeFeed from "./knowledge/KnowledgeFeed";
import {RecallCardDetail} from "./recall/RecallCardDetail";
import {RecallReviewSession} from "./recall/RecallReviewSession";
import {TaskDetailsPage} from "./task/TaskDetailsPage";
import {NoteDetailsPage} from "./note/NoteDetailsPage";
import {ProjectDetailsPage} from "./project/ProjectDetailsPage";
import Practice from "./practice/Practice";
import PracticeDetailsPage from "./practice/PracticeDetailsPage";
import {Reports} from "./reports/Reports";
import Trackers from "./tracker/Trackers";
import TrackerDetailsPage from "./tracker/TrackerDetailsPage";
import Roadmaps from "./roadmap/Roadmaps";
import RoadmapListPage from "./roadmap/RoadmapListPage";
import RoadmapModuleDetailsPage from "./roadmap/RoadmapModuleDetailsPage";
import RoadmapTopicDetailsPage from "./roadmap/RoadmapTopicDetailsPage";
function App() {

    return (
        <Router>
            <Routes>
                <Route path="/" element={<CompitoLandingPage/>}/>
                <Route path="/reports" element={<PrivateRouter> <Reports/> </PrivateRouter>}/>
                <Route path="/home" element={<PrivateRouter> <Home/> </PrivateRouter>}/>
                <Route path="/notes" element={<PrivateRouter> <Notes/> </PrivateRouter>}/>
                <Route path="/knowledge-feed" element={<PrivateRouter> <KnowledgeFeed/> </PrivateRouter>}/>
                <Route path="/note/new" element={<PrivateRouter> <Note/> </PrivateRouter>}/>
                <Route path="/note/:id" element={<PrivateRouter> <NoteDetailsPage/> </PrivateRouter>}/>
                <Route path="/planner" element={<PrivateRouter> <Planner/> </PrivateRouter>}/>
                <Route path="/projects" element={<PrivateRouter> <ProjectsPage/> </PrivateRouter>}/>
                <Route path="/project/:id" element={<PrivateRouter> <ProjectDetailsPage/> </PrivateRouter>}/>
                <Route path="/recall" element={<PrivateRouter> <Recall/> </PrivateRouter>}/>
                <Route path="/recall/:id" element={<PrivateRouter> <RecallCardDetail/> </PrivateRouter>}/>
                <Route path="/recall/review" element={<PrivateRouter> <RecallReviewSession/> </PrivateRouter>}/>
                <Route path="/practice" element={<PrivateRouter> <Practice/> </PrivateRouter>}/>
                <Route path="/practice/:id" element={<PrivateRouter> <PracticeDetailsPage/> </PrivateRouter>}/>
                <Route path="/roadmaps" element={<PrivateRouter> <RoadmapListPage/> </PrivateRouter>}/>
                <Route path="/roadmap/:id" element={<PrivateRouter> <Roadmaps/> </PrivateRouter>}/>
                <Route path="/roadmap/:roadmapId/module/:moduleId" element={<PrivateRouter> <RoadmapModuleDetailsPage/> </PrivateRouter>}/>
                <Route path="/roadmap/:roadmapId/topic/:topicId" element={<PrivateRouter> <RoadmapTopicDetailsPage/> </PrivateRouter>}/>
                <Route path="/trackers" element={<PrivateRouter> <Trackers/> </PrivateRouter>}/>
                <Route path="/tracker/:id" element={<PrivateRouter> <TrackerDetailsPage/> </PrivateRouter>}/>
                <Route path="/signin" element={<Signin/>}/>
                <Route path="/signup" element={<Signup/>}/>
                <Route path="/session" element={<PrivateRouter> <WorkSession/> </PrivateRouter>}/>
                <Route path="/settings" element={<PrivateRouter> <Settings/> </PrivateRouter>}/>
                <Route path="/task" element={<PrivateRouter> <Task/> </PrivateRouter>}/>
                <Route path="/task/:id" element={<PrivateRouter> <TaskDetailsPage/> </PrivateRouter>}/>
                <Route path="*" element={<NotFoundPage/>}/>
            </Routes>
        </Router>
    );
}

export default App;
